import * as React from "react";
import { inject, observer } from "mobx-react";
import ModelStore from "src/stores/ModelStore";
import "./ProductInfoComponent.scss";

interface IState {
  message: string;
  input: string;
}
interface IProps {
  modelStore?: ModelStore;
}
@inject("modelStore")
@observer
export default class IntroComponent extends React.Component<IProps, IState> {


  private clicked: boolean = false; 
  private timer: number;
  private cursorIndex: number;
  private message: string;
  private slogans: any[];

  

  constructor(props?: any, context?: any) {
    super(props, context);
    this.start = this.start.bind(this);
    this.type = this.type.bind(this);
    this.nextSlogan = this.nextSlogan.bind(this);
    this.clickField = this.clickField.bind(this);
    this.enableApp = this.enableApp.bind(this);
    this.state = {
      input: "",
      message: ""
      
    };
  }

  

  public render() {

    
  

    return (
      <div className="intro">
        <div className="panel">
          <h2>Was sollen wir verpacken?</h2>
          <input
            type="text"
            defaultValue={this.state.message}
            onClick={this.clickField}
            onKeyUp={this.enableApp}
          />
          <br />
          <p>Bitte tragen Sie oberhalb ihr Produkt ein</p>
          <button onClick={this.start} className={this.state.input.length > 0 ? "": "disabled" }>Los geht's</button>
        </div>
      </div>
    );
  }

  public componentDidMount(){
      const modelStore = this.props.modelStore as ModelStore;
      this.slogans = modelStore.menu[0].phrases;
      this.clicked = false; 

      this.startTypeWriter();
  }
  
  public componentWillUnmount() {
    window.clearInterval(this.timer);
    window.clearTimeout(this.timer);
  }
  private start() {
    const modelStore = this.props.modelStore as ModelStore;
    modelStore.selectedProduct = this.state.input;
    modelStore.start();
  }
  private startTypeWriter() {
    if(!this.slogans){
      return;
    }
    this.message = this.slogans[0].title;
    this.cursorIndex = 0;
    this.timer = window.setInterval(this.type, 100);
    // console.log("StartTypewriter", this.message );
  }
  private type() {
    this.cursorIndex += 1;
    this.setState({ message: this.message.substr(0, this.cursorIndex) });
    if (this.cursorIndex === this.message.length) {
      window.clearInterval(this.timer);
      this.timer = window.setTimeout(this.nextSlogan, 2000);
    }
  }
  private nextSlogan() {
    const first: string = this.slogans[0];
    this.slogans.push(first);
    this.slogans.shift();
    this.startTypeWriter();
  }
  private clickField(evt: React.SyntheticEvent) {

    window.clearInterval(this.timer);
    window.clearTimeout(this.timer);

    if(!this.clicked){
      (evt.currentTarget as HTMLInputElement).value = "";  
      this.clicked = true; 
    }
  }
  private enableApp(evt: React.SyntheticEvent){
    this.setState({input: (evt.currentTarget as HTMLInputElement).value });
  }
}



// WEBPACK FOOTER //
// ./src/components/IntroComponent.tsx